<template>
  <div class="box-body">
    <div class="row m-b-15">
      <div class="row center-block">
        <div class="col-md-12">
          <div>
            <br />
            <div class="box-body form-left">
              <div>
                <div class="input-group">
                  <span class="input-group-addon"><span class="text-red">＊ </span>活動名稱(後台)</span>
                  <input class="form-control" placeholder="" type="text" v-model="activity.name" maxlength="45">
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon"><span class="text-red">＊ </span>活動名稱(前端)</span>
                  <input class="form-control" placeholder="" type="text" v-model="activity.title" maxlength="45">
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon"><span class="text-red">＊ </span>活動順序</span>
                  <input class="form-control" placeholder="" type="text" v-model="activity.sort" maxlength="2">
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">活動說明(後台)</span>
                  <textarea class="form-control" placeholder="活動說明" v-model="activity.description" maxlength="256"></textarea>
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon"><span class="text-red">＊ </span>活動說明(前端)</span>
                  <textarea class="form-control" placeholder="活動說明" v-model="activity.content" maxlength="256"></textarea>
                </div>
                <br />
              </div>
            </div>
            <div class="box-body form-right">
              <div>
                <div class="input-group cr-schedule">
                  <span class="input-group-addon">
                    <span class="text-red">＊ </span>活動開始時間
                  </span>
                  <date-time-picker :date="activity.aTime.start" :option="timeoption" :limit="startLimit"></date-time-picker>
                  <!--<input class="form-control w-200" placeholder="" type="text" v-model="menuTime.start">-->
                </div>
                <br />
              </div>
              <div>
                <div class="input-group cr-schedule">
                        <span class="input-group-addon">
                          <span class="text-red">＊ </span>活動結束時間
                        </span>
                  <date-time-picker :date="activity.aTime.end" :option="timeoption" :limit="endLimit"></date-time-picker>
                  <!--<input class="form-control w-200" placeholder="" type="text" v-model="menuTime.end">-->
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">活動備註</span>
                  <textarea class="form-control" placeholder="活動說明" v-model="activity.remark"></textarea>
                </div>
                <br />
              </div>
            </div>
            <div class="col-xs-12 p-sm-10-p m-x-10 form-left">
              <h5>參與店家</h5>
              <!-- 參與店家 -->
              <muti-select-two :setting="addStoresSetting"></muti-select-two>
              <!--{{addStoresSetting.choose}}-->
            </div>
            <hr class="box-body col-xs-12">
            <div class="col-xs-12 p-sm-10-p m-x-10 form-left">
              <div>
                <h4>限制規則</h4>
              </div>
            </div>
            <div class="box-body form-left">
              <div>
                <div class="input-group">
                  <span class="input-group-addon">
                    訂單類型
                  </span>
                  <div>
                    <multiselect
                      v-model="activity.strategy_data[0].limit.order_type"
                      :options="orderType"
                      :searchable="false"
                      :allow-empty="true"
                      :close-on-select="false"
                      placeholder="訂單類型"
                      :show-labels="false"
                      :multiple="true"
                      label="label"
                      track-by="label"
                    >
                    </multiselect>
                  </div>
                </div>
                <br>
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">
                    訂單方案
                  </span>
                  <div>
                    <multiselect
                      v-model="activity.strategy_data[0].limit.order_method"
                      :options="orderMethod"
                      :searchable="true"
                      :allow-empty="true"
                      :close-on-select="false"
                      placeholder="訂單方案"
                      :show-labels="false"
                      :multiple="true"
                      label="label"
                      track-by="label"
                    >
                    </multiselect>
                  </div>
                </div>
                <br>
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">
                    取貨方式
                  </span>
                  <div>
                    <multiselect
                      v-model="activity.strategy_data[0].limit.delivery_type"
                      :options="deliveryType"
                      :searchable="false"
                      :allow-empty="true"
                      :close-on-select="false"
                      placeholder="取貨方式"
                      :show-labels="false"
                      :multiple="true"
                      label="label"
                      track-by="label"
                    >
                    </multiselect>
                  </div>
                </div>
                <br>
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">
                    付款地點
                  </span>
                  <div>
                    <multiselect
                      v-model="activity.strategy_data[0].limit.pay_place_type"
                      :options="payPlaceType"
                      :searchable="false"
                      :allow-empty="true"
                      :close-on-select="false"
                      placeholder="付款地點"
                      :show-labels="false"
                      :multiple="true"
                      label="label"
                      track-by="label"
                    >
                    </multiselect>
                  </div>
                </div>
                <br>
              </div>
            </div>
            <div class="box-body form-right">
              <div>
                <div class="input-group">
                  <span class="input-group-addon">訂單最低應付金額(單位：元)</span>
                  <input class="form-control" placeholder="包含扣除折價" type="text" v-model="activity.strategy_data[0].limit.min_total_paid_money" maxlength="45">
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">訂單最低總金額(單位：元)</span>
                  <input class="form-control" placeholder="" type="text" v-model="activity.strategy_data[0].limit.min_total_money" maxlength="45">
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">訂單最低購買數(單位：個)</span>
                  <input class="form-control" placeholder="" type="text" v-model="activity.strategy_data[0].limit.min_total_amount" maxlength="45">
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">限制主單(或團長)最低應付金額(單位：元)</span>
                  <input class="form-control" placeholder="包含扣除折價" type="text" v-model="activity.strategy_data[0].limit.min_paid_money" maxlength="45">
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">限制主單(或團長)最低總金額(單位：元)</span>
                  <input class="form-control" placeholder="" type="text" v-model="activity.strategy_data[0].limit.min_money" maxlength="45">
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">限制主單(或團長)最低購買數(單位：個)</span>
                  <input class="form-control" placeholder="" type="text" v-model="activity.strategy_data[0].limit.min_amount" maxlength="45">
                </div>
                <br />
              </div>
              <div>
                <div class="input-group">
                  <span class="input-group-addon">限制子單(跟團單)最低訂單數(單位：筆)</span>
                  <input class="form-control" placeholder="" type="text" v-model="activity.strategy_data[0].limit.min_sub_order_amount" maxlength="45">
                </div>
                <br />
              </div>
            </div>
            <!--<div class="col-xs-12">-->
            <!--<div class="box-body">-->
            <!--<div class="dataTables_wrapper form-inline dt-bootstrap">-->
            <!--<storelist-table :storeList="getList" @getIndex="getNewList"/>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->
          </div>
        </div>
      </div>
    </div>
    <!-- /.box-body -->
    <div class="box-footer text-center">
      <button class="btn btn-success" @click="checkActivity">
        新增
      </button>
      <button class="btn btn-fail" @click="$router.go(-1)">
        取消
      </button>
    </div>
    <div v-for="(cInfo, index) in couponList">
      <div class="modal fade" :id="'couponRegisterModal' + index" role="dialog">
        <div class="modal-dialog choose-modal">
          <div class="modal-content pull-left">
            <div class="modal-header pull-left w-100-p">
              <button type="button" class="close" data-dismiss="modal">&times;</button>
              <h4 class="modal-title text-left">優惠券設定</h4>
            </div>
            <div style="width: calc(100% - 80px)" class="card m-y-1 pull-left m-y-10 c-pointer" @click="clickCoupon()"
                 :data-target="'#couponRegisterModal' + index" data-toggle="modal" v-if="coupon.coupon_info"
            >
              <div class="coupon-left p-10">
                <h4><span v-if="coupon.coupon_info.name">{{coupon.coupon_info.name}}</span><span v-else>優惠券名稱</span></h4>
                <h5><span v-if="coupon.coupon_info.description">{{coupon.coupon_info.description}}</span><span v-else>優惠券描述....</span></h5>
                <h5>到期：<span v-if="coupon.time_config.start_time.time">{{coupon.time_config.start_time.time}} ~ {{coupon.time_config.end_time.time}}</span><span v-else>{{nowTime}} ~ {{nowTime}}</span></h5>
              </div>
              <div class="coupon-right p-10">
                <div class="v-middle">
                  $<span v-if="coupon.coupon_info.discount_value">{{coupon.coupon_info.discount_value}}</span><span v-else>10</span>
                </div>
              </div>
            </div>
            <!--
            <div class="coupon-edit-block pull-left">
              <button v-if="couponList.length > 1" class="btn btn-danger" @click="couponList.splice(index, 1)"><i class="fa fa-trash"></i></button>
              <br v-if="couponList.length > 1">
              <button class="btn btn-default m-t-5"><i class="fa fa-pencil"></i></button>
            </div>
            -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
// Require needed datatables modules
import 'datatables.net'
import 'datatables.net-bs'
import { mapActions } from 'vuex'
import moment from 'moment'
export default {
  components: {
    'date-time-picker': datetimePicker
  },
  data () {
    return {
      activityMethod: 1,
      // modal test
      orderType: [
        {label: '一般單', value: 1},
        {label: '團購單 - 團長', value: 2},
        {label: '團購單 - 團員', value: 3}
      ],
      orderMethod: [
        {label: '當日單', value: 1},
        {label: '預訂單', value: 2}
      ],
      deliveryType: [
        {label: '自取', value: 1},
        {label: '內用', value: 2},
        {label: '外送', value: 3},
        {label: '內用-桌邊掃碼', value: 21}
      ],
      payPlaceType: [
        {label: '線上結帳', value: 10},
        {label: 'POS店家結帳', value: 50}
      ],
      coupon: {
        type: {label: '固定起迄時間', value: 1},
        price_type: {label: '免稅', value: 1},
        discount_type: {label: '折扣金額', value: 1},
        setting: {label: '依訂單購買商品數設定', value: 1},
        useType: {label: '品牌型', value: 2}
      },
      otherCoupon: [],
      // end
      otherCouponList: [
        {label: 'Nidin優惠券', value: 1, code: '1231231dz'},
        {label: '柴犬優惠券', value: 2, code: '324efxde'},
        {label: '你好優惠券', value: 3, code: '654trrgxx'}
      ],
      addStoresSetting: {
        class: 'buy-add-store',
        options: [],
        choose: []
      },
      addCouponStoresSetting: {
        class: 'coupon-store',
        options: [],
        choose: []
      },
      /*
      addStoresExceptionSetting: {
        class: 'add-ex-store',
        options: [],
        choose: []
      },
      */
      deadType: [
        {label: '固定起迄時間', value: 'all_fixed'},
        {label: '固定結束時間', value: 'day_fixed'},
        {label: '發送日幾天後', value: 'day_day'}
      ],
      priceType: [
        {label: '免稅', value: 1},
        {label: '未稅', value: 2},
        {label: '含稅', value: 3}
      ],
      discountType: [
        {label: '折扣金額', value: 1}
        // {label: '折數', value: 2}
      ],
      couponSetting: [
        {label: '依訂單購買商品數設定', value: 'SC00001'},
        {label: '依個人訂單消費特定商品數', value: 'SC00002'},
        {label: '依個人訂單購買金額', value: 'SC00003'}
      ],
      useType: [
        {label: '品牌型', value: 2},
        {label: '門市型', value: 3}
      ],
      usageValue: [],
      brandList: [],
      content: {
        bindingStoreList: [],
        bindingBrandList: [],
        bindingProdList: []
      },
      brandDefault: '',
      brandBrief: [],
      storeBrief: [],
      scheduleTime: '',
      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: ''
        }
      },
      show: {
        back: false
      },
      giftSelect: 0,
      tableIndex: 1,
      menuId: 0,
      menuName: '',
      storeId: 0,
      startTime: {
        time: ''
      },
      endtime: {
        time: ''
      },
      giftList: [
        {label: '依店家訂單消費金額滿額送', value: 1},
        {label: '依店家訂單商品個數滿額送', value: 2},
        {label: '依店家訂單消費指定商品數量滿額送', value: 3}
      ],
      timeoption: {
        type: 'min',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD HH:mm:ss',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      startLimit: [
        {
          type: 'fromto',
          from: moment().format('YYYY-MM-DD HH:mm:ss')
        }
      ],
      endLimit: [
        {
          type: 'fromto',
          from: moment().format('YYYY-MM-DD HH:mm:ss')
        }
      ],
      info: {
        menuName: '夏日菜單',
        menu_id: 123323,
        start_time: '2017-03-31 12:22:32',
        end_time: '2017-03-31 12:22:32',
        update_time: '2017-03-31 12:22:32',
        create_time: '2017-03-31 12:22:32'
      },
      menu_schedule_list: [
        {
          'schedule_id': 122,
          'store_id': 1,
          'store_name': '金山店',
          'menu_id': 1,
          'start_time': '2017-07-24 08:00:00',
          'end_time': '2017-08-01 00:00:00',
          'status': 1,
          'update_time': '2017-01-14 16:09:16',
          'create_time': '2017-01-14 16:09:16'
        },
        {
          'schedule_id': 123,
          'store_id': 2,
          'store_name': '中山店',
          'menu_id': 2,
          'start_time': '2017-07-24 08:00:00',
          'end_time': '2017-08-01 00:00:00',
          'status': 1,
          'update_time': '2017-01-14 16:09:16',
          'create_time': '2017-01-14 16:09:16'
        }
      ],
      couponList: [
        {
          coupon_info: { set_name: '', set_description: '', name: '', description: '', remark: '', discount_type: '', discountType: {label: '折扣金額', value: 1}, discount_value: '', priceType: {label: '免稅', value: 1}, price_type: '' },
          usage_store_config: { isFollowStore: true, usageStoreType: { label: '品牌型', value: 2 }, usage_store_type: '', usageStoreValue: '', usage_store_value: '', usage_method: 'manual', manual_store_ids: [] },
          time_config: { timeType: { label: '固定起迄時間', value: 'all_fixed' }, time_type: '', startTime: { time: '' }, endTime: { time: '' }, start_time: '', end_time: '', use_start_day: '', use_tolerance_day: '' },
          is_group_usage: 1,
          isGroupUsage: true,
          amount_unit: 1,
          coupon_strategy: {
            ruleCode: {label: '依訂單購買商品數設定', value: 'SC00001'},
            rule_code: '',
            name: '',
            description: '',
            limit: {
              min_amount: 1,
              min_money: '',
              order_method: '',
              orderMethod: '',
              order_types: [],
              orderTypes: [],
              delivery_types: [],
              deliveryTypes: []
            },
            setting: {
              one_max_amount: null,
              ratio: 1,
              lowest_unit_price: 0,
              money_unit: ''
            },
            store_exception_items: [
              {
                products: [],
                store_ids: []
              }
            ]
          }
        }
      ],
      activity: {
        name: '',
        description: '',
        title: '',
        content: '',
        remark: '',
        sort: 1,
        start_time: '',
        end_time: '',
        aTime: {
          start: { time: '' },
          end: { time: '' }
        },
        store_ids: [],
        strategy_data: [
          {
            ruleCode: 'SA00001',
            rule_code: 'SA00001',
            limit: {
              order_type: [],
              order_method: [],
              delivery_type: [],
              pay_place_type: [],
              min_total_paid_money: '',
              min_total_money: '',
              min_total_amount: '',
              min_paid_money: '',
              min_money: '',
              min_amount: '',
              min_sub_order_amount: ''
            },
            setting: {
              money_unit: '',
              max_count: '',
              vendorCustomProductList: [],
              vendor_custom_product_list: [],
              vendorList: [],
              amount_unit: 1
            },
            store_exception_items: [{
              products: [],
              productList: [],
              store_ids: []
            }]
          }
        ]
      },
      productBrief: [],
      productChoseBrief: [],
      nowTime: moment().format('YYYY-MM-DD HH:mm')
    }
  },
  created () {
    this.getMarketingStores()
    this.giftSelect = 1
    // 店家
    if (this.getRoleType === 10) {
      this.useType = [
        {label: '品牌型', value: 2},
        {label: '門市型', value: 3}
      ]
    }
    // this.getStoreBrief()
  },
  methods: {
    ...mapActions(['setMenuStartTime', 'setMenuEndTime']),
    addChooseTag (newTag) {
      const tag = {
        name: newTag,
        id: ''
      }
      this.productChoseBrief.push(tag)
      this.activity.setting.vendorCustomProductList.push(tag)
    },
    addCouponChooseTag (newTag) {
      const tag = {
        name: newTag,
        id: ''
      }
      this.productChoseBrief.push(tag)
      this.couponList.forEach(function (coupon) {
        var type = coupon.coupon_strategy.ruleCode.value
        var vcpList = coupon.coupon_strategy.setting.vendorCustomProductList
        if (vcpList && type === 'SC00002') vcpList.push(tag)
      })
    },
    addCouponTag (newTag) {
      const tag = {
        name: newTag,
        vendor_custom_id: ''
      }
      this.productBrief.push(tag)
      this.couponList.forEach(function (coupon) {
        var type = coupon.coupon_strategy.ruleCode.value
        var pList = coupon.coupon_strategy.store_exception_items[0].products
        if (pList && type !== 'SC00002') pList.push(tag)
      })
    },
    addTag (newTag) {
      const tag = {
        name: newTag,
        vendor_custom_id: ''
      }
      this.productBrief.push(tag)
      this.activity.store_exception_items[0].products.push(tag)
    },
    setCoupon (type, callback) {
      var couponSet = {
        coupon_info: { set_name: '', set_description: '', name: '', description: '', remark: '', discount_type: '', discountType: {label: '折扣金額', value: 1}, discount_value: '', priceType: {label: '免稅', value: 1}, price_type: '' },
        usage_store_config: { isFollowStore: true, usageStoreType: { label: '品牌型', value: 2 }, usage_store_type: '', usageStoreValue: '', usage_store_value: '', usage_method: 'manual', manual_store_ids: [] },
        time_config: { timeType: { label: '固定起迄時間', value: 'all_fixed' }, time_type: '', startTime: { time: '' }, endTime: { time: '' }, start_time: '', end_time: '', use_start_day: '', use_tolerance_day: '' },
        is_group_usage: 1,
        isGroupUsage: true,
        amount_unit: 1,
        coupon_strategy: {
          ruleCode: {label: '依訂單購買商品數設定', value: 'SC00001'},
          name: '',
          description: '',
          limit: {
            min_amount: 1,
            min_money: '',
            order_method: '',
            orderMethod: '',
            order_types: [],
            orderTypes: [],
            delivery_types: [],
            deliveryTypes: []
          },
          setting: {
            one_max_amount: null,
            ratio: 1,
            lowest_unit_price: 0,
            vendorCustomProductList: [],
            vendor_custom_product_list: [],
            money_unit: 100
          },
          store_exception_items: [
            {
              products: [],
              store_ids: []
            }
          ]
        }
      }
      var coupon = couponSet
      if (type === 1 || type === 'SC00001') coupon.coupon_strategy.ruleCode = {label: '依訂單購買商品數設定', value: 'SC00001'}
      else if (type === 2 || type === 'SC00002') {
        coupon.coupon_strategy.ruleCode = {label: '依個人訂單消費特定商品數', value: 'SC00002'}
        coupon.coupon_strategy.store_exception_items = []
      } else if (type === 3 || type === 'SC00003') coupon.coupon_strategy.ruleCode = {label: '依個人訂單購買金額', value: 'SC00003'}
      callback(coupon)
    },
    addCoupon () {
      var self = this
      this.setCoupon(this.giftSelect, function (coupon) {
        self.couponList.push(coupon)
      })
    },
    clickCoupon () {
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    getStoreBrief (brandId) {
      this.storeBrief = []
      var self = this
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            self.storeBrief.push(obj)
          }
        }
      })
    },
    getBrandBrief () {
      var self = this
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list
          for (let i = 0; i < bList.length; i++) {
            let obj = {label: bList[i].name, value: bList[i].brand_id}
            self.brandBrief.push(obj)
          }
        }
      })
    },
    changeOtherCoupon (current) {
      this.couponList.push(current)
    },
    removeOtherCoupon (current) {
      var self = this
      var removeId = ''
      this.couponList.find(function (coupon, index) {
        if (coupon.code) {
          if (current.code === coupon.code) {
            removeId = index
            return
          }
        }
      })
      if (removeId) self.couponList.splice(removeId, 1)
    },
    getMarketingStores () {
      this.addStoresSetting.options = []
      this.addStoresSetting.choose = []
      this.addCouponStoresSetting.options = []
      this.addCouponStoresSetting.choose = []
      // this.addStoresExceptionSetting.options = []
      // this.addStoresExceptionSetting.choose = []
      var self = this
      var url = '/promotion/' + this.$route.params.marketing_id + '/storeList?&list_sort=store_name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var list = response.data.list
          for (let i = 0; i < list.length; i++) {
            let obj = {label: list[i].store_name, value: list[i].store_id}
            self.addStoresSetting.options.push(obj)
            self.addCouponStoresSetting.options.push(obj)
            // self.addStoresExceptionSetting.options.push(obj)
            if (!self.brandList.find(brand => brand.value === list[i].brand_id)) self.brandList.push({ label: list[i].brand_name, value: list[i].brand_id })
          }
          self.usageValue = self.brandList
        }
      })
    },
    changeStoreType (select, id) {
      // console.log(select, id)
      // this.cInfo.usage_store_config.usageStoreValue =
      var index = id.split('-')[2]
      console.log(index)
      if (select.value === 2) {
        this.usageValue = this.brandList
        this.couponList[index].usage_store_config.usageStoreValue = this.usageValue[0]
      } else if (select.value === 3) {
        this.usageValue = this.addStoresSetting.options
        this.couponList[index].usage_store_config.usageStoreValue = this.usageValue[0]
      }
    },
    checkActivity () {
      console.log(this.activity)
      console.log(this.couponList)
      var a = this.activity
      // var cList = this.couponList
      var sD = a.strategy_data[0] // 活動策略
      var msg = ''
      if (!a.name) msg = '活動名稱(後台)未填'
      else if (!a.title) msg = '活動名稱(前台)未填'
      else if (!a.sort) msg = '活動排序未填'
      else if (!a.content) msg = '活動說明(前台)未填'
      else if (typeof a.sort !== Number) msg = '活動排序非數字'
      else if (!a.aTime.start.time) msg = '活動開始時間未填'
      else if (!a.aTime.end.time) msg = '活動結束時間未填'
      else if (!this.addStoresSetting.choose.length) msg = '參與活動店家未選'
      else if (!sD.ruleCode) msg = '贈送規則未選'
      else if (sD.ruleCode === 'SA00001') {
        if (!sD.setting.money_unit) msg = '活動累積滿多少金額，送一份優惠券未填'
        else if (typeof sD.setting.money_unit !== Number) msg = '活動累積滿多少金額，送一份優惠券非數字'
        else if (!sD.setting.max_count) msg = '活動最高贈送份數未填'
        else if (typeof sD.setting.max_count !== Number) msg = '活動最高贈送份數非數字'
      } else if (sD.ruleCode === 'SA00002') {
        if (sD.setting.amount_unit === '') msg = '活動達成多少商品數量，送優惠券未填'
        else if (typeof sD.setting.amount_unit !== Number) msg = '活動達成多少商品數量，送優惠券非數字'
        else if (!sD.setting.lowest_unit_price) msg = '活動最高贈送份數未填'
        else if (typeof sD.setting.lowest_unit_price !== Number) msg = '活動最高贈送份數未填非數字'
        else if (!sD.setting.max_count) msg = '活動最高贈送份數未填'
        else if (typeof sD.setting.max_count !== Number) msg = '活動最高贈送份數非數字'
      } else if (sD.ruleCode === 'SA00003') {
        if (sD.setting.amount_unit === '') msg = '活動達成多少商品數量，送優惠券未填'
        else if (typeof sD.setting.amount_unit !== Number) msg = '活動達成多少商品數量，送優惠券非數字'
        else if (!sD.setting.max_count) msg = '活動最高贈送份數未填'
        else if (typeof sD.setting.max_count !== Number) msg = '活動最高贈送份數非數字'
        else if (sD.setting.vendorCustomProductList) msg = '活動購買指定商品未選擇'
      } else {
        /*
        for (var i = 0; i < cList.length; i++) {
          checkCouponList()
        }
        */
      }
      console.log(msg)
    }
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    },
    scheduleListNew () {
      var menuList = {}
      var oldList = this.menu_schedule_list
      for (var key in oldList) {
        // console.log(oldList[key].menu_id)
        menuList[oldList[key].menu_id] = {
          menu_id: oldList[key].menu_id,
          storeList: []
        }
      }
      for (var k in oldList) {
        menuList[oldList[k].menu_id].storeList.push({
          store_id: oldList[k].store_id,
          store_name: oldList[k].store_name,
          start_time: oldList[k].start_time,
          end_time: oldList[k].end_time,
          status: oldList[k].status,
          update_time: oldList[k].update_time,
          create_time: oldList[k].create_time,
          schedule_id: oldList[k].schedule_id
        })
      }
      return menuList
    },
    getList () {
      // var num = 0
      if (this.$route.name === 'upScheduleOne') {
        var oneList = this.scheduleListNew[this.menuId].storeList
        this.menuTime.start.time = oneList[0].start_time
        this.menuTime.end.time = oneList[0].end_time
        return oneList
      } else {
        var list = []
        for (var key in this.scheduleListNew) {
          for (var k in this.scheduleListNew[key].storeList) {
            list.push(this.scheduleListNew[key].storeList[k])
          }
        }
        return list
      }
    }
  },
  watch: {
    'menuTime.start.time' () {
      this.endLimit = [
        {
          type: 'fromto',
          from: this.menuTime.start.time
        }
      ]
      this.setMenuStartTime(this.menuTime.start.time)
    },
    'menuTime.end.time' () {
      this.startLimit = [
        {
          type: 'fromto',
          from: moment().format('YYYY-MM-DD HH:mm:ss'),
          to: this.menuTime.end.time
        }
      ]
      this.setMenuEndTime(this.menuTime.end.time)
    },
    'content.bindingBrandList' () {
      var self = this
      this.storeBrief = []
      this.content.bindingStoreList = []
      this.content.bindingBrandList.forEach(function (array) {
        const brandId = array.value
        self.getStoreBrief(brandId)
      })
    },
    giftSelect () {
      var self = this
      this.setCoupon(this.giftSelect, function (coupon) {
        self.couponList = [coupon]
      })
    },
    'addStoresSetting.choose' () {
      this.activity.store_ids = this.addStoresSetting.choose
    }
    /*
    'addStoresExceptionSetting.choose' () {
      this.activity.strategy_data[0].store_exception_items[0].store_ids = this.addStoresExceptionSetting.choose
    },
    */
  }
}
</script>
<style lang="sass">
.coupon-left
  float: left
  width: calc(100% / 3 * 2 + 15px)
  padding-right: 5px
.coupon-right
  float: left
  background: #3c8dbc
  width: calc(100% / 3 - 15px)
  position: absolute
  right: 0
  top: 0
  height: 100%
  border-left: 5px black dashed
  border-radius: 0px 6px 6px 0px
  color: white
  .v-middle
    position: absolute
    top: calc(50% - 28.5px)
    font-size: 40px
    text-align: center
    width: 100%
    left: 0
</style>
<style lang="sass" scoped>
// .ranges
  display: none
.coupon.form-left, .coupon.form-right
  width: 50%
  float: left
.coupon.form-right
  padding: 20px 20px 20px 10px
.coupon.form-left
  padding: 20px 10px 20px 20px
.coupon.form-left.w-100-p
  padding: 20px 20px
.min-item.active, .hour-item.active, .day.checked
  background: #222d32 !important
.w-200
  width: 180px !important
.m-b-15
  margin-bottom: 15px !important
.btn-all-store
  position: absolute
  right: 10px
  z-index: 30
  top: 0px
.input-white
  border: 0px
@media screen and (max-width: 767px)
  .p-sm-10-p
    padding-right: 10px !important
    padding-left: 10px !important
@media screen and (min-width: 768px)
  .p-sm-10-p
    padding-right: calc(20% - 15px) !important
    padding-left: calc(20% + 10px) !important
@media screen and (min-width: 991px)
  .p-sm-10-p
    padding-right: calc(10% - 10px) !important
    padding-left: 10% !important
</style>
<style lang="sass">
  .multiselect__content-wrapper, .multiselect__content-wrapper *
    z-index: 99
  .m-t-0
    margin-top: 0px
  .input-group .form-control
    z-index: auto !important
  textarea
    max-width: 100%
    min-widht: 100%
  .modal-title
    width: calc(100% - 20px)
  @media screen and (max-width: 767px)
    .input-group.cr-schedule .cov-vue-date .cov-datepicker
      width: calc(100vw - 185px)
  @media screen and (min-width: 768px)
    .input-group.cr-schedule .cov-vue-date .cov-datepicker
      width: calc(50vw - 190px)
  @media screen and (min-width: 991px)
    .input-group .cov-vue-date .cov-datepicker
      max-width: calc(30vw - 190px)
</style>



// WEBPACK FOOTER //
// ActivityBuyForm.vue?226500dc